export const DIALOG_CROSS_ICON = 'dialog cross icon';
